var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-summary-card"},[_c('strong',{staticClass:"policy-summary-heading"},[_vm._v("根据文章，简要提炼核心内容")]),_c('div',{staticClass:"policy-summary-title",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title || '政策详情'))]),_c('div',{staticClass:"policy-summary-preview",attrs:{"title":_vm.preview}},[_vm._v(_vm._s(_vm.previewText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }